module.exports = __webpack_public_path__ + "assets/c08b069b34b9a1de0320a2f2da6f5848.png";